module.exports = __webpack_public_path__ + "img/logo_login.490e2c79.svg";